export const MEMBERSHIP = {
  List: '/memberships',
  Create: '/memberships',
  Details: '/memberships/{id}',
  Update: '/memberships/{id}',
  Delete: '/memberships/{id}',
  Bulk: '/memberships/bulk',
  History: '/memberships/{id}/histories',
};
